import * as loadingState from '@blueberry/constants/loadingState';

export const types = {
  FETCH_ACCOMPLISHMENTS: 'FETCH_ACCOMPLISHMENTS',
  FETCH_ACCOMPLISHMENTS_SUCCESS: 'FETCH_ACCOMPLISHMENTS_SUCCESS',
  FETCH_ACCOMPLISHMENTS_FAILURE: 'FETCH_ACCOMPLISHMENTS_FAILURE',
  TOGGLE_CONCEPT_CHECKED: 'TOGGLE_CONCEPT_CHECKED',
  TOGGLE_CONCEPT_CHECKED_SUCCESS: 'TOGGLE_CONCEPT_CHECKED_SUCCESS',
  TOGGLE_CONCEPT_CHECKED_FAILURE: 'TOGGLE_CONCEPT_CHECKED_FAILURE',
};

export const fetchAccomplishments = data => ({
  type: types.FETCH_ACCOMPLISHMENTS,
  payload: data,
});

export const fetchAccomplishmentsSuccess = data => ({
  type: types.FETCH_ACCOMPLISHMENTS_SUCCESS,
  payload: {
    ...data,
  },
});

export const fetchAccomplishmentsFailure = () => ({
  type: types.FETCH_ACCOMPLISHMENTS_FAILURE,
});

export const toggleConceptChecked = ({
  conceptId,
  subtopicId,
  topicId,
  isChecked,
}) => ({
  type: types.TOGGLE_CONCEPT_CHECKED,
  payload: {
    conceptId,
    subtopicId,
    topicId,
    isChecked,
  },
});

export const toggleConceptCheckedSuccess = ({
  concepts,
  subtopics,
  topics,
  conceptCheckedCount,
}) => ({
  type: types.TOGGLE_CONCEPT_CHECKED_SUCCESS,
  payload: {
    concepts,
    subtopics,
    topics,
    conceptCheckedCount,
  },
});

export const toggleConceptCheckedFailure = () => ({
  type: types.TOGGLE_CONCEPT_CHECKED_FAILURE,
});

const initialState = {
  loadingStatus: loadingState.EMPTY,
  conceptCheckedCount: 0,
  conceptCount: 0,
  masteryRate: 0,
  concepts: [],
  subtopics: [],
  topics: [],
  topicRateChart: {
    topicNames: [],
    allSeries: [],
    snapaskSeries: [],
    schoolSeries: [],
  },
  conceptStatus: loadingState.EMPTY,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ACCOMPLISHMENTS:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case types.FETCH_ACCOMPLISHMENTS_SUCCESS: {
      const {
        conceptCheckedCount,
        conceptCount,
        masteryRateTotal,
        masteryRate,
        concepts,
        subtopics,
        topics,
        topicRateChart,
      } = action.payload;

      return {
        ...state,
        loadingStatus: loadingState.READY,
        conceptCheckedCount,
        conceptCount,
        masteryRateTotal,
        masteryRate,
        concepts,
        subtopics,
        topics,
        topicRateChart: {
          ...topicRateChart,
        },
      };
    }
    case types.TOGGLE_CONCEPT_CHECKED:
      return {
        ...state,
        conceptStatus: loadingState.LOADING,
      };
    case types.TOGGLE_CONCEPT_CHECKED_SUCCESS: {
      const {
        conceptCheckedCount,
        concepts,
        subtopics,
        topics,
      } = action.payload;

      return {
        ...state,
        conceptStatus: loadingState.READY,
        conceptCheckedCount,
        concepts,
        subtopics,
        topics,
      };
    }
    default:
      return state;
  }
};

export default reducer;
export const getConceptCount = state => state.accomplishment.conceptCount;
export const getConceptCheckedCount = state =>
  state.accomplishment.conceptCheckedCount;
export const getMasteryRate = state => state.accomplishment.masteryRate;
export const getMasteryRateTotal = state =>
  state.accomplishment.masteryRateTotal;
export const getTopics = state => state.accomplishment.topics;
export const getSubtopics = state => state.accomplishment.subtopics;
export const getConcepts = state => state.accomplishment.concepts;
export const getLoadingStatus = state => state.accomplishment.loadingStatus;
export const getTopicRateChart = state => state.accomplishment.topicRateChart;
export const getConceptStatus = state => state.accomplishment.conceptStatus;



// WEBPACK FOOTER //
// ./app/redux/accomplishment.js